import { render, staticRenderFns } from "./FareBreakdown.vue?vue&type=template&id=d97e0e44&"
import script from "./FareBreakdown.vue?vue&type=script&lang=js&"
export * from "./FareBreakdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports